<template>
  <div :id="id + '_rep'" class="cat-single-child" :title="title">
    <h2 v-if="title" data-label-type="heading">{{ title }}</h2>

    <cat-error
      v-if="childCount == 0"
      :id="id"
      :level="2"
      :message="instructionMessage"
    ></cat-error>
    <cat-errors :id="id" :container="true" :errors="errors"></cat-errors>
    <p v-if="hint" class="hint">{{ hint }}</p>
    <slot name="intro"></slot>
    <slot></slot>
    <slot name="buttons"> </slot>
  </div>
</template>

<script lang="ts">
import { defineComponent, inject } from "vue";
import { defaultResolveTxt } from "@/components/field-element";
import CatError from "@/components/catError/catError.vue";
import CatErrors from "@/components/catErrors/catErrors.vue";
import {} from "vue";

export default defineComponent({
  setup() {
    // Inject the global value
    const resolveTxt = inject("resolveTxt", defaultResolveTxt);
    const displayParams = inject("displayParams", false);

    return {
      resolveTxt,
      displayParams
    };
  },
  name: "CatSingleChildRepeater",
  components: {
    CatError,
    CatErrors
  },
  props: {
    id: {
      type: [String, Number]
    },
    title: [String],
    instructionMessage: [String],
    hint: [String],
    errors: [Array],
    childCount: [Number]
  }
});
</script>
